<template>
  <f7-panel
    left
    reveal
    resizable
    class="panel panel-left not-animated content-menu"
    :opened="showToDefault"
    :visible-breakpoint="1024"
  >
    <f7-page>
      <div class="content-menu-header">
        <div class="menu-header-item">
          <span class="version-app">{{ version }}</span>
          <img
            class="image_logo"
            :src="APP_LOGO"
          >
        </div>
      </div>
      <f7-list
        accordion-list
        class="content-list-menu"
      >
        <ul>
          <li
            v-for="(item, index) in elements"
            :key="index"
          >
            <template
              v-if="$t(item.name) !== '' && $t(item.name) !== 'INFORMATION'"
            >
              <a
                :href="item.url"
                class="item-content item-link"
              >
                <div class="item-inner">
                  <div class="item-title">{{ $t(item.name) }}</div>
                </div>
              </a>
              <f7-accordion-content>
                <f7-list media-list>
                  <f7-list-item
                    v-for="(itemMenu, index2) in item.menus"
                    :key="index2"
                    class="panel-close close"
                    :class="{
                      highlight: getActualMenuSelected == itemMenu.url,
                    }"
                    accordion-list
                    @click="navigateTo(itemMenu.url)"
                  >
                    <f7-icon
                      v-if="typeof itemMenu.icon !== `undefined`"
                      slot="media"
                      :class="`icon-menu ${itemMenu.icon}`"
                      :link="itemMenu.url"
                      width="32"
                      height="32"
                    />
                    <a v-if="typeof itemMenu.icon !== 'undefined'">{{
                      $t(itemMenu.name)
                    }}</a>
                    <a v-else>{{ $t(itemMenu.name) }}</a>
                    <br>
                  </f7-list-item>
                </f7-list>
              </f7-accordion-content>
            </template>
            <template
              v-else-if="
                $t(item.name) === '' && getActualMenuSelected === undefined
              "
            >
              <f7-list-item
                v-for="(itemMenu, index2) in item.menus"
                :key="index2"
                class="panel-close close highlight"
                :class="{ highlight: getActualMenuSelected == itemMenu.url }"
                accordion-list
                @click="navigateTo(itemMenu.url)"
              >
                <f7-icon
                  v-if="typeof itemMenu.icon !== 'undefined'"
                  slot="media"
                  :class="`icon-menu ${itemMenu.icon}`"
                  :link="itemMenu.url"
                  width="32"
                  height="32"
                />
                <a v-if="typeof itemMenu.icon !== 'undefined'">{{
                  $t(itemMenu.name)
                }}</a>
                <a v-else>{{ $t(itemMenu.name) }}</a>
                <br>
              </f7-list-item>
            </template>
            <template v-else>
              <f7-list-item
                v-for="(itemMenu, index2) in item.menus"
                :key="index2"
                class="panel-close close"
                :class="{ highlight: getActualMenuSelected == itemMenu.url }"
                accordion-list
                @click="navigateTo(itemMenu.url)"
              >
                <f7-icon
                  v-if="typeof itemMenu.icon !== 'undefined'"
                  slot="media"
                  :class="`icon-menu ${itemMenu.icon}`"
                  :link="itemMenu.url"
                  width="32"
                  height="32"
                />
                <a v-if="typeof itemMenu.icon !== 'undefined'">{{
                  $t(itemMenu.name)
                }}</a>
                <a v-else>{{ $t(itemMenu.name) }}</a>
                <br>
              </f7-list-item>
            </template>
          </li>
        </ul>
      </f7-list>
      <f7-block v-if="validateExploitationData">
        <div class="info-item-marker">
          <span class="item-info-marker-header">{{ $t("point") }}</span>
          <span class="item-content-marker-header">{{
            currentPoint.pointName
          }}</span>
          <span class="item-info-marker-header">{{ $t("country") }}</span>
          <span class="item-content-marker-header">{{
            currentPoint.country
          }}</span>
          <span class="item-info-marker-header">{{ $t("region") }}</span>
          <span class="item-content-marker-header">{{ currentRegion }}</span>
          <span class="item-info-marker-header">{{ $t("province") }}</span>
          <span class="item-content-marker-header">{{
            currentPoint.provinceName
          }}</span>
          <span class="item-info-marker-header">{{ $t("station") }}</span>
          <span class="item-content-marker-header">
            {{ currentPoint.stationName }}</span>
        </div>
      </f7-block>
    </f7-page>
  </f7-panel>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { APPLICATION_NAME, APP_LOGO } from '../js/constants';
import store from '../store/index';

export default {
  name: 'LeftPanel',
  store,
  props: {
    elements: { type: Array, default: () => [] },
    showToDefault: { type: Boolean, default: true },
    version: { type: String, default: '1.0.0' },
  },
  data() {
    return {
      APPLICATION_NAME,
      APP_LOGO,
      alwaysOpen: 0,
    };
  },
  computed: {
    appName() {
      return this.APPLICATION_NAME;
    },
    appLogo() {
      return localStorage.getItem('applogo') || this.APP_LOGO;
    },
    validateExploitationData() {
      return this.currentPoint.pointName !== '';
    },
    ...mapState('authentication', ['user']),
    ...mapState('Mopeco', [
      'currentPoint',
      'currentRegion',
      'showFloor',
      'showIrrigation',
      'showCrops',
      'showOptimalCropDistribution',
    ]),
    ...mapGetters('authentication', [
      'getActualMenuSelected',
      'getPermissions',
    ]),
  },
  methods: {
    navigateTo(path) {
      if (path === '/accounts/loginPage/') {
        this.logoutPressed();
      } else {
        this.setActualMenuSelected(path);
        this.$f7.views.main.router.navigate(path, { reloadCurrent: true });
      }
    },
    logoutPressed() {
      const self = this;
      self.$f7.panel.close('left', false);
      self.logout();
    },
    isGranted(menu) {
      let access = false;
      switch (menu.permission) {
        case 'floor':
          access = this.showFloor;
          break;
        case 'irrigation':
          access = this.showIrrigation;
          break;
        case 'crops':
          access = this.showCrops;
          break;
        case 'optimalCropDistribution':
          access = this.showOptimalCropDistribution;
          break;
        default:
          access = true;
          break;
      }
      return access;
    },
    ...mapActions('authentication', ['logout', 'setActualMenuSelected']),
  },
};
</script>

<style lang="scss">
.content-list-menu {
  ul {
    li {
      &.accordion-item a {
        .item-inner {
          justify-content: flex-start !important;
          align-content: center;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          .item-title {
            color: var(--fr-kinder);
            padding-left: 0;
          }
          &::after {
            height: 0;
          }
          &::before {
            color: var(--fr-nutella) !important;
          }
        }
      }

      &.accordion-item-opened {
        .item-content:not(:last-child) {
          border-bottom: 1px solid var(--f7-list-item-border-color);
        }
      }
      &.panel-close {
        &:hover {
          background: linear-gradient(270deg, #03bcf4, #03bcf4);
          a {
            color: var(--fr-leters) !important;
          }
        }
        &.highlight {
          background: #e7e2df;
          a {
            color: var(--fr-kinder) !important;
            font-weight: 600;
          }
        }
        .item-content:not(:last-child) {
          border-bottom: 1px solid var(--f7-list-item-border-color);
          .item-inner {
            &::after {
              height: 0;
            }
          }
        }
      }
      a {
        color: #74838c;
      }
      a:focus,
      a:hover {
        color: var(--fr-kinder) !important;
      }
    }
  }
}

li.accordion-item.accordion-item-opened {
  background: #fffbf8;
}

.toolbar_panel {
  bottom: 0px !important;
  padding: 5px 10px;
}
.chip-label {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
}
.list ul ul {
  padding-left: 0px;
}
.item-content {
  cursor: pointer;
}
.content-menu-header {
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
  padding: 2px 5px 2px 5px;
}
.content-menu .list ul {
  background: white;
}
.content-menu .list-group-title {
  border-bottom: 1px solid #ececec;
}
.content-menu .page-content {
  background: #f7f8fa;
}
//TODO: Ver porqué se ha alinea a la derecha | Alinear nombre del menú a la izquierda
.content-menu .list .item-inner {
  justify-content: flex-start;
  align-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.item-media {
  margin-left: 0 !important;
  min-width: 24px !important;
}

.icon-menu {
  width: 24px;
  height: 24px;
}
.item-info-marker-header {
  color: #74838c;
  font-size: 13px;
  margin-top: 12px;
  padding-left: 10px;
}
.item-content-marker-header {
  color: #232323;
  font-size: 13px;
  font-weight: bold;
  padding-left: 10px;
}
.icon-home {
  background-image: url("../static/img/icon_inicio.svg");
}

.icon-taks {
  background-image: url("../static/img/ic_setting.svg");
}

.icon-explotation {
  background-image: url("../static/img/ic_explotation.svg");
}

.icon-soil {
  background-image: url("../static/img/ic_soil.svg");
}

.icon-irrigation {
  background-image: url("../static/img/ic_irrigation.svg");
}

.icon-crops {
  background-image: url("../static/img/ic_crops.svg");
}
.icon-optimal-irrigation {
  background-image: url("../static/img/ic_optimal-crop-distribution.svg");
}
.icon-logout {
  background-image: url("../static/img/ic_exitout.svg");
}

div.item-inner a {
  color: #003d3e !important;
}
.image_logo {
  width: 90%;
  padding: 10px 5px 5px 10px;
}
.panel {
  min-width: 100px;
  max-width: 90vw;
}
.scaled {
  width: 120px;
  height: auto;
}
</style>
